import $ from 'jquery'
import _ from 'lodash'
import Collapsible from 'scoreboard/components/collapsible'
import i18n from 'scoreboard/components/i18n'
import errorStackTraceHeader from './error-stack-trace-header.hbs'
import errorStackTraceContent from './error-stack-trace-content.hbs'

const CollapsibleStackTrace = Collapsible.extend(/** @lends CollapsibleStackTrace.prototype */{

    initialize(options = {}) {
		// Be careful here, we must wrap the header and content in their templates
		// but allow the provided options to override the default attributes
		const header = options.header || i18n.get('common.details')
		options = _.extend({
			collapsed: false,
			maxHeight: this.getMaxHeight()
		}, options, {
			header: errorStackTraceHeader(header),
			content: errorStackTraceContent(options.stackTrace)
		})
		Collapsible.prototype.initialize.call(this, options)
    },

	render: function() {
		this.on('resize', () => {
			this.options.maxHeight = this.getMaxHeight()
		})
		return Collapsible.prototype.render.apply(this, arguments)
	},

	getMaxHeight: function() {
		// To keep the scrollbars within the panel and not the overall dialog, we
		// need to grab some heights and set a max-height on the panel content.
		let bodyHeight = $('body').height()
		// Amount of spacing above and below the dialog
		// as well as the dialog title's height.
		let dialogSpacing = 350
		return bodyHeight - dialogSpacing
	}

})

export default CollapsibleStackTrace
CollapsibleStackTrace.__filename__ = 'components/collapsible-stack-trace.js'
